import { useBreakpoints } from '@/lib/device/useBreakpoint'
import { useEffect, useRef, type ReactElement } from 'react'
import type { DefinitionListItemProps } from '../_components/DefinitionListItem.client'
import type { DefinitionListSyncContextValue } from '../DefinitionListProvider.client'

export function useDefinitionListRowSync(
  visibleItems: ReactElement<DefinitionListItemProps>[],
  sync: DefinitionListSyncContextValue | null,
) {
  const rowRefs = useRef<(HTMLElement | null)[]>([])
  const reportRowSizes = sync?.reportRowSizes
  const isFullDisplay = sync?.isFullDisplay
  const { isDesktopWidth } = useBreakpoints()

  useEffect(() => {
    if (!reportRowSizes) {
      return
    }

    const timer = setTimeout(() => {
      reportRowSizes(
        visibleItems.map((_, rowIndex) => rowRefs.current[rowIndex]?.offsetHeight ?? 0),
      )
    }, 0)

    return () => clearTimeout(timer)
  }, [visibleItems, reportRowSizes, isFullDisplay, isDesktopWidth])

  return {
    isWaitingForSync: !!sync && sync.rowSizes.length === 0,
    rowRefs,
    rowSizes: sync?.rowSizes,
  }
}
